export default __webpack_public_path__ + "static/media/faq.b87b4e84.svg";